import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Binder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { of, switchMap } from 'rxjs';

@Component({
  selector: 'lgb-binder-admin-form',
  imports: [
    UiModule,
    FormsModule,
    RouterModule,
    CommonModule
  ],
  templateUrl: './binder-admin-form.html',
  styleUrl: './binder-admin-form.css',
})
export class BinderAdminForm {
  readonly binderS=inject(BinderService);
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);
  readonly binder=signal<Binder>(new Binder());
  readonly nbBinder=signal(100);
  readonly showCode=signal(true);
  img: File;

  //ui  
  readonly loading=signal(false);
  readonly preview=signal<string>(null);
  readonly error=signal<string>(null);
  readonly msg=signal<string>(null);
  readonly isNew=computed(() => (this.binder().ident==null));

  constructor(){
    this.loading.set(true);
    this.route.paramMap
      .pipe(
        switchMap(param => ((param.get('id'))? this.binderS.getBinder(param.get('id')) : of(new Binder())))
      ).subscribe(b => {
        this.binder.set(b);
        this.loading.set(false);
      });
  }

  setPreview(src: string){
    this.preview.set(src);
  }

  getSrc(){
    let src: string=null;

    if(this.binder()?.img)
      src=this.binderS.getImg(this.binder().img);
    if(this.preview())
      src=this.preview();

    let result: string[]=[];
    if(src)
      result.push(src);

    return result;
  }

  setFile(event: Event){
    const input=event.target as HTMLInputElement;

    if(!input.files || input.files.length===0)
      this.img=null;
    else
      this.img=input.files[0];
  }

  setBinder(){
    if(this.checkImg()){
      this.loading.set(true);
      this.error.set(null);
      this.binderS.setBinder(this.binder(), this.img)
        .subscribe({
          next: binder => {
            this.msg.set(((!this.binder().ident)? 'Binder ajouté.' : 'Binder modifié.'));
            this.binder.set(binder);
            this.loading.set(false);
          },
          error: e => this.error.set(e)
        });
    }
  }

  checkImg(){
    let isValid: boolean=(!this.isNew() || this.img!=null);

    if(!isValid)
      this.error.set('Une image est obligatoire.');

    return isValid;
  }

  nbCard(){
    let nbCard: number=0;
    if(this.binder().height && this.binder().width && this.binder().nbPage)
      nbCard=this.binder().height*this.binder().width*this.binder().nbPage;
    return nbCard;
  }

  nbScan(){
    return ((this.binder().nbPage)? 1.5*this.binder().nbPage : 0);
  }

  rm(){
    if(confirm('Voulez-vous supprimer ce Binder ?')){
      this.loading.set(true);
      this.binderS.rmBinder(this.binder().ident)
        .subscribe({
          next: () => this.router.navigate('admin-binder'),
          error: e => {
            this.error.set(e);
            this.loading.set(false);
          }
        })
    }
  }

  bucket(){
    this.loading.set(true);
    this.binderS.bucket(this.binder().ident, this.nbBinder(), this.showCode(), `${this.binder().refProvider}.zip`)
      .subscribe({
        next: () => {
          this.msg.set(`${this.nbBinder()} binders générés`);
          this.loading.set(false);
        },
        error: e => this.msg.set(e)
      });
  }
}
